import { WireFunnelType } from 'scenes/common/types';
import { WireMotorFormData } from 'scenes/motor/types';
import { MotorFunnelState } from 'scenes/motor/flows/types';
import {
  getSelectedCoverType,
  getQuoteNumber,
  getSelectedInsuranceOption,
  isFlybuysMember,
  getSelectedExcess,
} from 'scenes/motor/selectors';
import { wireCoverType } from 'scenes/motor/api/quote/marshaller/coverage';
import { toQuoteNumberWithDashes } from 'scenes/common/helpers/quote';
import { toProductSubtype } from 'scenes/common/analytics/marshaller/formData';

import { toWirePayment } from './payment';
import { toWirePolicy } from './policy';

export const toWireFormData = (
  state: MotorFunnelState,
  quoteNumber?: string
): WireMotorFormData => ({
  quoteNumber: toQuoteNumberWithDashes(quoteNumber || getQuoteNumber(state)),
  productType: WireFunnelType.Motor,
  productSubtype: toProductSubtype(
    WireFunnelType.Motor,
    wireCoverType[getSelectedCoverType(state)]
  ),
  quoteAmountWithExtras:
    getSelectedInsuranceOption(state)?.premium.annualPrice || '',
  flybuysStatus: isFlybuysMember(state),
  excessAmount: getSelectedExcess(state).amount.toString(),
  payment: toWirePayment(state),
  policy: toWirePolicy(state),
});
